__turbopack_context__.v({
  "collapse": "collapse-module__J6sInW__collapse",
  "content": "collapse-module__J6sInW__content",
  "expanded": "collapse-module__J6sInW__expanded",
});
